import { CommonMessage } from './CommonMessage';
import { MessageType } from './MessageType';

export interface OpenAckPayload {
  serverInterval?: number;
  serverAttempts?: number;
  clientInterval?: number;
  connId?: string;
  encoder?: string;
  websocketSessionId: string;
}

export class OpenAckMessage implements CommonMessage {
  t = MessageType.OPEN_ACK;
  public d: OpenAckPayload;

  constructor(payload: OpenAckPayload) {
    this.d = payload;
  }
}
